<template>
  <carousel
    class="destaque"
    :navigationEnabled="true"
    :per-page="1"
    :pagination-enabled="true"
    :loop="true"
    :autoplay="true"
    :autoplay-timeout="5000"
    navigationNextLabel='<img  class="pass_d" src="/img/direita-rosa.png" />'
    navigationPrevLabel='<img  class="pass_e" src="/img/esquerda-rosa.png" />'
  >
    <slide  v-for="(item, index) in items"
      :key="index">
      <a :href="item.link">
      <div
        class="banner_destaque"
        :style="'background-image: url(' + item.image + ')'"
      ></div>
      <div class="infos">
        <p class="categoria-destaque vendas">Futuro</p>
        <h3 class="titulo-destaque">
          {{item.name}}
        </h3>
      </div>
      </a>
    </slide>
  </carousel>
</template>

<script>
import { Carousel, Slide } from "vue-carousel";
export default {
  props: ["items"],
  data() {
    return {
      width: screen.width,
      banner1: "http://localhost/img/DOBRA.png",
    };
  },
  components: {
    Carousel,
    Slide,
  },
  methods: {
    navigateTo(index) {
      this.slider = index;
      this.$refs.carouselSelector.goToPage(index);
    },
  },
  mounted() {
    // setTimeout(() => {
    //   this.$refs["carouselSelector"].onResize();
    //   this.$refs["carouselSelector"].goToPage(0);
    // }, 200);
  },
};
</script>

<style lang="scss" rel="stylesheet" media="all">
@import "resources/assets/sass/website/_variables.scss";
.destaque {
  display: flex;
  flex-direction: column;
  h3 {
    color: $pink;
    font-family: $font-inter;
    font-size: 30px;
  }
  a{
    display: flex;
    flex-direction: column;
  }
  .banner_destaque {
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    @media (max-width: 996px) {
      width: 99%;
      height: 400px;
    }
    @media (max-width: 775px) {
      width: 500px;
      height: 290px;
    }
    @media (max-width: 575px) {
      align-items: center;
      display: flex;
      width: 99%;
      height: 290px;
    }
    @media (max-width: 450px) {
      height: 238px;
    }
    @media (max-width: 350px) {
      height: 166px;
    }
  }
  .infos {
    .categoria-destaque {
      font-size: 20px;
      font-weight: 400;
      font-family: $font-inter;
      margin-top: 20px;
      width: 145px;
    }
    .titulo-destaque {
      color: #1a1b1d;
      font-family: $font-inter;
      font-weight: 700;
      font-size: 25px;
      @media (max-width: 575px) {
        font-size: 22px;
      }
    }
  }
  .VueCarousel-pagination {
    display: block !important;
    .VueCarousel-dot-container {
      position: absolute;
      bottom: 70px;
      right: 0px;
      @media (max-width: 775px){
          bottom: 90px;
      }
    }
    .VueCarousel-dot {
      position: relative;
      background-color: transparent !important;
      &::after {
        content: "";
        width: 8px;
        height: 8px;
        border-radius: 100%;
        background-color: #c4c4c4;
        position: absolute;
        top: 8px;
        left: 8px;
      }
      &--active::after {
        background-color: #ff006f;
      }
    }
  }
  .VueCarousel-navigation-prev[data-v-453ad8cd] {
    left: unset;
    right: 100px !important;
    top: -35px;
    position: absolute;
    @media (max-width: 400px){
        right: 60px !important;
    }
}
.VueCarousel-navigation-next[data-v-453ad8cd] {
    right: 53px !important;
    top: -35px;
    position: absolute;
}
}
.metaverso {
  color: #8d02fb;
  text-decoration: underline;
  text-underline-offset: 5px;
}
.tecnologia {
  color: #2f7ddf;
  text-decoration: underline;
  text-underline-offset: 5px;
}
.marketing {
  color: #97a500;
  text-decoration: underline;
  text-underline-offset: 5px;
}
.futuro {
  color: #0702fb;
  text-decoration: underline;
  text-underline-offset: 5px;
}
.agronegocio {
  color: #5ccb4a;
  text-decoration: underline;
  text-underline-offset: 5px;
}
.vendas {
  color: #d17db9;
  text-decoration: underline;
  text-underline-offset: 5px;
}
.pass_d, .pass_e{
    width: 25px !important;
    @media (max-width: 400px){
        width: 20px !important;
    }
}
</style>
